//
import PchPurchaseInvoiceModel from '@/models/Purchase/PchPurchaseInvoice'

/**
 * 
 */
export default class PchPurchaseInvoice {

  /**
   * 
   */
  static delete(pchPurchaseInvoice) {
    return pchPurchaseInvoice.delete()
  }

  /**
   * 
   */
  static model() {
    return PchPurchaseInvoiceModel
  }

  /**
   * 
   */
  static toList() {
    return class extends PchPurchaseInvoiceModel {
      static includes = [        
        'pch_payment_condition',
        'pch_provider.pch_provider_account',
        'pch_provider_account_movement.pch_type_provider_account_movement',
        'pch_provider_account_movement.pch_provider_payment.pch_detail_provider_payment_sheet',
        'pch_provider_branch_offices.g_commune',
        'pch_purchase_order_has_invoice_numbers.pch_purchase_order.g_originator_user.hr_employee',
      ]
    }
  }
}